export type CatalogNavigationItem = {
  catalogKey: string;
  name: string;
  iconUrl?: string;
  displayMode: 'standalone' | 'modal';
  sourceUrl?: string;
  adapterKey?: string;
  detailPrefix?: string;
  updatePolicy?: 'follow' | 'custom';
  hasIndependentCode?: boolean;
  loadItemJson?: boolean;
  listShape?: 'square' | 'rectangle' | 'landscape';
};

const FALLBACK_NAVIGATION: CatalogNavigationItem[] = [
  {
    catalogKey: 'hero',
    name: '英雄图鉴',
    displayMode: 'standalone',
  },
];

export function parseCatalogNavigation(
  gameKey: string,
  catalogs: Array<{
    catalogKey: string;
    name: string;
    displayMode: 'standalone' | 'modal';
    sourceUrl?: string;
    adapterKey?: string;
    detailPrefix?: string;
    hasIndependentCode?: boolean;
    iconUrl?: string;
    settings?: {
      loadItemJson?: boolean;
      listShape?: 'square' | 'rectangle' | 'landscape';
      updatePolicy?: 'follow' | 'custom';
    };
  }>,
): CatalogNavigationItem[] {
  const items = catalogs
    .map<CatalogNavigationItem>((row) => ({
      catalogKey:
        row.catalogKey === 'heroes' && row.adapterKey !== 'generic-json-v1'
          ? 'hero'
          : row.catalogKey,
      name: row.name,
      displayMode: row.displayMode,
      sourceUrl: row.sourceUrl || '',
      adapterKey: row.adapterKey || '',
      detailPrefix: row.detailPrefix || '',
      updatePolicy: row.settings?.updatePolicy === 'custom' ? 'custom' : 'follow',
      hasIndependentCode: row.hasIndependentCode === true,
      iconUrl: row.iconUrl || '',
      loadItemJson: row.settings?.loadItemJson ?? row.displayMode === 'standalone',
      listShape: row.settings?.listShape === 'rectangle' || row.settings?.listShape === 'landscape' ? row.settings.listShape : 'square',
    }));
  return items.length ? items : FALLBACK_NAVIGATION;
}

export function fallbackCatalogNavigation(): CatalogNavigationItem[] {
  return FALLBACK_NAVIGATION.map((item) => ({ ...item }));
}
